import axios from '@axios'

export default {
  getReferrals(page, field) {
    return axios.post(`platform/referrals/list?page=${page}`, field)
  },
}
